import { POIShape } from './POIShape';
import * as THREE from 'three';
import { SceneSettingsData } from '../core/SceneSettingsData';
import { AppSettingsData } from '../core/AppSettingsData';
import { POI } from '../poi/POI';

export class SphereShape extends POIShape {
    constructor(
        poi: POI,
        sceneSettings?: SceneSettingsData,
        appSettings?: AppSettingsData
    ) {
        super(poi, sceneSettings, appSettings, {});
        
        // When the scene's geometry resolution changes, recreate the sphere.
        this.sceneSettings?.geometryResolution.on(() => this.recreateGeometry());
    }

    protected override createGeometry(): THREE.BufferGeometry {
        const resolution = this.sceneSettings?.geometryResolution.value ?? 1.0;
        
        // Define base segment counts, then scale by resolution
        const baseWidthSegments = 32;
        const baseHeightSegments = 16;
        
        const widthSegments = Math.max(8, Math.ceil(baseWidthSegments * resolution));
        const heightSegments = Math.max(6, Math.ceil(baseHeightSegments * resolution));

        return new THREE.SphereGeometry(0.5, widthSegments, heightSegments);
    }
} 